<app-music-dialog title="Sleep timer" size="sm" [open]="ui.sleepTimerOpen()" (openChange)="onOpenChange($event)">
  <p class="mb-3 text-sm text-gray-400">Pause playback after:</p>
  <div class="grid grid-cols-4 gap-2">
    @for (m of presets; track m) {
      <button type="button" (click)="choose(m)"
        class="h-10 rounded-full bg-white/5 text-sm text-gray-300 hover:bg-white/10 focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-400">{{ m }} min</button>
    }
  </div>
  <button type="button" (click)="choose('end-of-track')"
    class="mt-3 h-10 w-full rounded-full bg-white/5 text-sm text-gray-300 hover:bg-white/10 focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-400">End of track</button>
  <form class="mt-3 flex gap-2" (submit)="$event.preventDefault(); custom(minutes)">
    <input #minutes type="number" min="1" max="720" inputmode="numeric" placeholder="Custom minutes" aria-label="Custom minutes"
      class="h-10 min-w-0 flex-1 rounded-full border border-white/10 bg-white/5 px-4 text-sm text-white placeholder-gray-500 focus:border-indigo-400 focus:outline-none" />
    <button type="submit" class="h-10 rounded-full bg-indigo-600 px-4 text-sm font-medium text-white hover:bg-indigo-500 focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-400">Set</button>
  </form>
  @if (invalid()) {
    <p class="mt-2 text-xs text-amber-400" role="alert">Enter a number of minutes between 1 and 720.</p>
  }
  <div dialogFooter class="flex justify-end border-t border-white/10 px-5 py-3">
    <button type="button" (click)="cancel()" [disabled]="!armed()"
      class="h-10 rounded-full px-4 text-sm text-gray-300 hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-400 disabled:opacity-40">Cancel timer</button>
  </div>
</app-music-dialog>
